// extracted by mini-css-extract-plugin
export default {"field":"field--amRbvlRqqV","remove-icon":"remove-icon--4tP3n1wWng","removeIcon":"remove-icon--4tP3n1wWng"};